/**
 * Convert a multi-line plain-text suggestion into ProseMirror nodes that
 * insert as one inline run: text nodes joined by `hardBreak` nodes. This
 * mirrors what a user would produce by typing Shift+Enter for line breaks,
 * so the inserted content lives inside the current paragraph rather than
 * fragmenting the document into separate block paragraphs.
 *
 * Leading/trailing whitespace is trimmed so a suggestion that ends with a
 * stray newline doesn't append an empty hardBreak after the last line.
 * Returns an empty array for empty/whitespace-only input — callers should
 * guard against this since ProseMirror's Text.fromJSON rejects empty text
 * nodes, and `insertContent([])` is a no-op anyway.
 */
export function suggestionContentToInlineNodes(
  content: string,
): Array<Record<string, unknown>> {
  const trimmed = content.trim();
  if (!trimmed) return [];
  const lines = trimmed.split(/\r?\n/);
  const nodes: Array<Record<string, unknown>> = [];
  lines.forEach((line, i) => {
    if (i > 0) nodes.push({ type: "hardBreak" });
    if (line) nodes.push({ type: "text", text: line });
  });
  return nodes;
}
